"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateProjectDetails = exports.restrictUserProject = exports.getProjectMemberNames = exports.getUnsignedRulesAgreementCount = exports.hasUserSignedRulesAgreement = exports.getPendingAssetCount = exports.areMembersLoaded = exports.areObligationsLoaded = exports.areAssetsLoaded = exports.getAssetCount = exports.canEditAnyProject = void 0;
const Asset_1 = require("../types/Asset");
/**
 * Returns true if the user can edit any project regardless of membership.
 */
function canEditAnyProject(user) {
    return user.role.permissions.updateProjects === 'all';
}
exports.canEditAnyProject = canEditAnyProject;
/**
 * Get a project's asset count.
 */
function getAssetCount(project) {
    var _a, _b;
    return (_b = (_a = project.assets) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : project.assetCount;
}
exports.getAssetCount = getAssetCount;
/**
 * Returns true if the restricted project has assets loaded.
 */
function areAssetsLoaded(project) {
    return Array.isArray(project.assets);
}
exports.areAssetsLoaded = areAssetsLoaded;
/**
 * Returns true if the restricted project has obligations loaded.
 */
function areObligationsLoaded(project) {
    return Array.isArray(project.obligations);
}
exports.areObligationsLoaded = areObligationsLoaded;
/**
 * Returns true if the restricted project has members loaded.
 */
function areMembersLoaded(project) {
    return Array.isArray(project.members);
}
exports.areMembersLoaded = areMembersLoaded;
/**
 * Counts the pending assets in a project.
 */
function getPendingAssetCount(project) {
    var _a, _b;
    return ((_b = (_a = project.assets) === null || _a === void 0 ? void 0 : _a.filter(Asset_1.isAssetPending).length) !== null && _b !== void 0 ? _b : project.pendingAssetCount);
}
exports.getPendingAssetCount = getPendingAssetCount;
/**
 * Returns true if the user has signed the current PRA.
 */
function hasUserSignedRulesAgreement({ user, project, }) {
    if (!project.projectRulesAgreementId) {
        // No PRA means no assets and obligations
        return false;
    }
    return project.rulesAgreementSignatures.some(({ userId, projectRulesAgreementId }) => userId === user.id &&
        projectRulesAgreementId === project.projectRulesAgreementId);
}
exports.hasUserSignedRulesAgreement = hasUserSignedRulesAgreement;
/**
 * Counts the number of members a project has that haven't signed the PRA.
 */
function getUnsignedRulesAgreementCount(project) {
    var _a, _b;
    return ((_b = (_a = project.members) === null || _a === void 0 ? void 0 : _a.filter((member) => !hasUserSignedRulesAgreement({ user: member.user, project })).length) !== null && _b !== void 0 ? _b : project.unsignedRulesAgreementCount);
}
exports.getUnsignedRulesAgreementCount = getUnsignedRulesAgreementCount;
function getProjectMemberNames(project) {
    var _a, _b;
    return ((_b = (_a = project === null || project === void 0 ? void 0 : project.members) === null || _a === void 0 ? void 0 : _a.map((member) => member.user.name)) !== null && _b !== void 0 ? _b : project.memberNames);
}
exports.getProjectMemberNames = getProjectMemberNames;
/**
 * Takes a detailed project and a user and returns the project with certain fields removed
 * depending on the user's global and project permissions.
 */
function restrictUserProject({ user, project, }) {
    // Owner with no PRA assigned
    if (user.id === project.ownerId && !project.projectRulesAgreementId) {
        // Owner can't manage assets before adding a PRA.
        const { assets } = project, restrictedProject = __rest(project, ["assets"]);
        return restrictedProject;
    }
    // Owner/member/admin that has signed the PRA
    if (project.projectRulesAgreementId &&
        hasUserSignedRulesAgreement({ user, project })) {
        // User has signed PRA. Return project as-is.
        return project;
    }
    // Member/admin that has not signed PRA
    const { assets, obligations, members } = project, restrictedProject = __rest(project, ["assets", "obligations", "members"]);
    return restrictedProject;
}
exports.restrictUserProject = restrictUserProject;
/**
 * Adds details to the project that are needed when the full project data is unavailable (see: restrictUserProject).
 */
function calculateProjectDetails(project) {
    const detailedProject = Object.assign(Object.assign({}, project), { assetCount: 0, pendingAssetCount: 0, unsignedRulesAgreementCount: 0, memberNames: [] });
    return Object.assign(Object.assign({}, detailedProject), { assetCount: getAssetCount(detailedProject), pendingAssetCount: getPendingAssetCount(detailedProject), unsignedRulesAgreementCount: getUnsignedRulesAgreementCount(detailedProject), memberNames: getProjectMemberNames(detailedProject) });
}
exports.calculateProjectDetails = calculateProjectDetails;
//# sourceMappingURL=data:application/json;base64,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